/*
  Free Access page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col } from 'react-bootstrap'
import FreeAccessForm from '../components/FreeAccessForm'

function FreeAccess () {
  return (
    <>
      <Helmet>
        <title>Free Access - FullStack.cash</title>
        <meta name='free access' content='Apply for free access.' />
      </Helmet>

      <Container className='py-5'>
        <Row>
          <Col>
            <h1>Apply for Free Access</h1>
            <p>
              <strong>
                Do you have an awesome Bitcoin Cash project? FullStack.cash provides
                free access to selected projects in order to support the BCH
                community. Describe your project in the message below and let
                us know how to contact you. Be sure to tell us how your project
                would help the Bitcoin Cash community or spread adoption.
                <br /><br />
                If selected, you will receive $100
                in free credit.
              </strong>
            </p>
            <p>
              Also, be sure to introduce yourself
              in <a href='https://t.me/permissionless_software' target='_blank' rel='noreferrer'>our Telegram channel</a>.
            </p>
            <FreeAccessForm />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default FreeAccess
